import React, { Component } from 'react';
import {
  Table,
  Pagination,
  Icon,
  Loader,
  Button,
  Popup,
  Dropdown,
  Checkbox,
} from 'semantic-ui-react';
import { getData, deleteData } from '../dataHelper';
import moment from 'moment';
import Message from '../Message';

class List extends Component {
  state = {
    isConfirm: false,
    limit: 20,
    completed: true,
    asset_id: '',
    plateNumberList: this.props.plateNumberList,
    plateNumber: '',
    data: [],
    activePage: 1,
    totalPages: 0,
    messageShow: false,
    messageType: '',
    messageInfo: '',
    loaderActive: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.plateNumber !== this.state.plateNumber) {
      this.fetchData();
    }
    if (prevState.activePage !== this.state.activePage) {
      this.fetchData();
    }
  }

  fetchData = () => {
    this.setState({ data: [], loaderActive: true });
    const { activePage, limit, plateNumber } = this.state;

    const asset_id = plateNumber ? plateNumber : '';

    getData(
      `${this.props.org}_delivery`,
      `page=${activePage - 1}&limit=${limit}&asset_id=${asset_id}`,
    )
      .then((response) => {
        const data = response.data.message;
        this.setState({
          data: data.data,
          totalPages: Math.ceil(data.total / data.limit),
          loaderActive: false,
        });
      })
      .catch((error) => error);
  };

  handleDelete = (id) => {
    this.setState({ isConfirm: false, data: [] });
    deleteData(`${this.props.org}_delivery`, id)
      .then((response) => {
        const { status } = response.data;
        if (status === 'success') {
          this.setState({
            messageShow: true,
            data: [],
          });
          this.fetchData();
        } else if (status === 'error') {
          this.setState({
            messageShow: true,
          });
        }
        setTimeout(() => this.setState({ messageShow: false }), 3000);
      })
      .catch((error) => console.error(error));
  };

  handleConfirm = (confirm) => {
    this.setState({ isConfirm: confirm });
  };

  pagination = (e, data) => {
    this.setState({ activePage: data.activePage });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      data: [],
      loaderActive: true,
    });
  };

  handleAssetSelect = (e, data) => {
    this.setState({ plateNumber: data.value });
  };

  handleAll = () => {
    this.setState({ plateNumber: '' });
  };

  whichColor = (date) => {
    let color = 'rgba(0,0,0,.87)';
    if (date.$date) {
      const diff = moment(date.$date).diff(moment(), 'days') + 1;
      if (diff > 15 && diff <= 30) {
        color = '#fab005';
      } else if (diff <= 15) {
        color = '#fa5252';
      }
    }
    return color;
  };

  render() {
    const {
      isConfirm,
      plateNumberList,
      plateNumber,
      data,
      activePage,
      totalPages,
      loaderActive,
      messageShow,
    } = this.state;

    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '10px 15px',
            padding: '15px 0',
          }}
        >
          <div>
            <Dropdown
              search
              selection
              options={plateNumberList}
              onChange={this.handleAssetSelect}
              value={plateNumber}
            />
            <Checkbox
              toggle
              onClick={this.handleAll}
              style={{ marginLeft: '10px' }}
              label='All'
              checked={plateNumber ? false : true}
            />
          </div>

          {data.length > 0 && (
            <div>
              <Pagination
                activePage={activePage}
                pointing
                secondary
                totalPages={totalPages}
                onPageChange={(e, data) => this.pagination(e, data)}
                firstItem={{
                  content: <Icon name='angle double left' />,
                  icon: true,
                }}
                lastItem={{
                  content: <Icon name='angle double right' />,
                  icon: true,
                }}
                prevItem={{ content: <Icon name='angle left' />, icon: true }}
                nextItem={{ content: <Icon name='angle right' />, icon: true }}
              />
            </div>
          )}
        </div>

        {messageShow && <Message type='warning' info='Successfully deleted.' />}

        <div style={{ width: '100%', overflowX: 'scroll' }}>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Sl No.</Table.HeaderCell>
                <Table.HeaderCell>Registration No.</Table.HeaderCell>
                <Table.HeaderCell>Purchase Date</Table.HeaderCell>
                <Table.HeaderCell>Chassis Number</Table.HeaderCell>
                <Table.HeaderCell>Engine Number</Table.HeaderCell>
                <Table.HeaderCell>CC</Table.HeaderCell>
                <Table.HeaderCell>Capacity</Table.HeaderCell>
                <Table.HeaderCell>Model</Table.HeaderCell>
                <Table.HeaderCell>Brand</Table.HeaderCell>
                <Table.HeaderCell>Colour</Table.HeaderCell>
                <Table.HeaderCell>Fuel Type</Table.HeaderCell>
                <Table.HeaderCell>Tax Token Validity</Table.HeaderCell>
                <Table.HeaderCell>Fitness Validity</Table.HeaderCell>
                <Table.HeaderCell>Route Permit Validity</Table.HeaderCell>
                <Table.HeaderCell>Insurance Validity</Table.HeaderCell>
                <Table.HeaderCell>User Name</Table.HeaderCell>
                <Table.HeaderCell>Insurance Certificate No.</Table.HeaderCell>
                <Table.HeaderCell>Registration On</Table.HeaderCell>
                <Table.HeaderCell>CNG Cylinder Retest Date</Table.HeaderCell>
                <Table.HeaderCell>
                  Fire Extinguisher Refill Date
                </Table.HeaderCell>
                <Table.HeaderCell>No. of Fire Extinguisher</Table.HeaderCell>
                <Table.HeaderCell>Driver License Expire Date</Table.HeaderCell>
                <Table.HeaderCell>Driver Name</Table.HeaderCell>
                <Table.HeaderCell>Driver Contact Number</Table.HeaderCell>
                <Table.HeaderCell>Remarks</Table.HeaderCell>
                <Table.HeaderCell>Created</Table.HeaderCell>
                <Table.HeaderCell>Last Edited</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.length > 0 &&
                data.map((item, index) => (
                  <Table.Row key={item.asset_id.$oid}>
                    <Table.Cell>{index + 1}</Table.Cell>
                    <Table.Cell>{item.asset_name}</Table.Cell>
                    <Table.Cell>
                      {item.purchase_date
                        ? moment(item.purchase_date.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>
                    <Table.Cell>{item.chassis_number}</Table.Cell>
                    <Table.Cell>{item.engine_number}</Table.Cell>
                    <Table.Cell>{item.cc}</Table.Cell>
                    <Table.Cell>{item.capacity}</Table.Cell>
                    <Table.Cell>{item.model}</Table.Cell>
                    <Table.Cell>{item.brand}</Table.Cell>
                    <Table.Cell>{item.color}</Table.Cell>
                    <Table.Cell>{item.fuel_type}</Table.Cell>
                    <Table.Cell
                      style={{
                        color: this.whichColor(item.tax_token_validity),
                      }}
                    >
                      {item.tax_token_validity
                        ? moment(item.tax_token_validity.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(item.fitness_validity),
                      }}
                    >
                      {item.fitness_validity
                        ? moment(item.fitness_validity.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(item.route_permit_validity),
                      }}
                    >
                      {item.route_permit_validity
                        ? moment(item.route_permit_validity.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(item.insurance_validity),
                      }}
                    >
                      {item.insurance_validity
                        ? moment(item.insurance_validity.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell>{item.username}</Table.Cell>
                    <Table.Cell>{item.insurance_certificate_no}</Table.Cell>
                    <Table.Cell>{item.registration_on}</Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(item.cng_cylinder_retest_date),
                      }}
                    >
                      {item.cng_cylinder_retest_date
                        ? moment(item.cng_cylinder_retest_date.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(
                          item.fire_extinguisher_refill_date,
                        ),
                      }}
                    >
                      {item.fire_extinguisher_refill_date
                        ? moment(
                            item.fire_extinguisher_refill_date.$date,
                          ).format('dddd, MMMM Do, YYYY, hh:mm:ss A')
                        : ''}
                    </Table.Cell>

                    <Table.Cell>{item.no_of_fire_extinguisher}</Table.Cell>

                    <Table.Cell
                      style={{
                        color: this.whichColor(item.driver_license_expiry_date),
                      }}
                    >
                      {item.driver_license_expiry_date
                        ? moment(item.driver_license_expiry_date.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                    </Table.Cell>

                    <Table.Cell>{item.driver_name}</Table.Cell>
                    <Table.Cell>{item.driver_contact_number}</Table.Cell>
                    <Table.Cell>{item.remarks}</Table.Cell>
                    <Table.Cell>
                      {item.created_at
                        ? moment(item.created_at.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                      {` by `}
                      {item.created_by_email}
                    </Table.Cell>
                    <Table.Cell>
                      {item.last_modified_at
                        ? moment(item.last_modified_at.$date).format(
                            'dddd, MMMM Do, YYYY, hh:mm:ss A',
                          )
                        : ''}
                      {` by `}
                      {item.modified_by_email}
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        positive
                        onClick={() => this.props.handleEdit(item)}
                        style={{ width: '100%', marginBottom: '10px' }}
                      >
                        Edit
                      </Button>
                      <Popup
                        trigger={
                          <Button
                            onClick={() => this.handleConfirm(item._id.$oid)}
                            style={{ width: '100%', marginBottom: '10px' }}
                          >
                            Delete
                          </Button>
                        }
                        content={
                          <div>
                            <Button
                              negative
                              onClick={() => this.handleDelete(item._id.$oid)}
                            >
                              Yes
                            </Button>
                            <Button onClick={() => this.handleConfirm(false)}>
                              No
                            </Button>
                          </div>
                        }
                        open={isConfirm === `${item._id.$oid}`}
                      />
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
          <div style={{ textAlign: 'center' }}>
            <Loader active={loaderActive} />
            {!loaderActive && data.length === 0 && <h3>No Data Found</h3>}
          </div>
        </div>
      </div>
    );
  }
}

export default List;
